import React from "react";

export default function DiscoverCourses() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
    >
      <circle
        cx="10.5"
        cy="10.5"
        r="7"
        fill="none"
        stroke="#bbbabf"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <line
        x1="20"
        y1="20"
        x2="15.75"
        y2="15.75"
        fill="none"
        stroke="#bbbabf"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </svg>
  );
}
